import { render, staticRenderFns } from "./regis-edit.vue?vue&type=template&id=80702eda&scoped=true"
import script from "./regis-edit.vue?vue&type=script&lang=ts"
export * from "./regis-edit.vue?vue&type=script&lang=ts"
import style0 from "./regis-edit.vue?vue&type=style&index=0&id=80702eda&prod&lang=scss&scoped=true"
import style1 from "./regis-edit.vue?vue&type=style&index=1&id=80702eda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80702eda",
  null
  
)

export default component.exports